import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../src/constants/theme";
import AppRoutes from "../src/routes/appRoutes";
import './styles/ToastStyles.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      
      {/* Your main routes */}
      <AppRoutes />

      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        closeButton={false}
        pauseOnHover
        theme="light"
        style={{ fontSize: '0.8rem' }}
        toastClassName="custom-toast-font"
        bodyClassName="custom-toast-body-size"
      />
    </ThemeProvider>
  );
}

export default App;
